import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { runMigrations } from './utils/storage'
import { registerServiceWorker } from './utils/registerServiceWorker'
import { setupNativeShell } from './utils/nativeSetup'
import { setupPush } from './utils/pushNotifications'
import App from './App.jsx'

// ترحيل أي بيانات محفوظة من نسخة أقدم قبل إقلاع التطبيق
runMigrations()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// ضبط شريط الحالة داخل غلاف أندرويد/iOS (لا أثر له في المتصفح)
setupNativeShell()

// تسجيل الجهاز للإشعارات المرسلة. تنبيهات الأذان مستقلة عن هذا تماماً
// وتعمل بلا إنترنت — انظر utils/prayerNotifications.js
setupPush()

// يجعل التطبيق قابلاً للتثبيت ويعمل دون اتصال.
// البث الصوتي الحيّ مستثنى من التخزين عمداً.
registerServiceWorker({
  onUpdateAvailable: (applyUpdate) => {
    // نسأل بدل إعادة التحميل فجأة أثناء استماع المستخدم
    if (window.confirm('تتوفر نسخة محدّثة من التطبيق. هل تريد تحديثها الآن؟')) {
      applyUpdate()
    }
  },
})
